import { CHECKOUT_EVENTS } from '../constants/angular-events';

app.directive('memberPointsSummary', [
  'checkoutService',
  '$compile',
  'logger',
  function (checkoutService, $compile, logger) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        scope.$on('tax.fee.update', function () {
          checkoutService
            .requestPartial('cart', 'member_point_summary', {
              is_checkout_tax_update: true,
            })
            .then(function (res) {
              element.html($compile(res.data)(scope));
            })
            .catch(function (err) {
              logger.log('Unable to load member point summary ', err);
            });
        });
        scope.$on(CHECKOUT_EVENTS.CART.SUMMARY.CHANGED, function () {
          checkoutService
            .requestPartial('cart', 'member_point_summary')
            .then(function (res) {
              element.html($compile(res.data)(scope));
            })
            .catch(function (err) {
              logger.log('Unable to load member point summary ', err);
            });
        });
        scope.$on(CHECKOUT_EVENTS.CART.SUMMARY.RELOAD, function () {
          checkoutService
            .requestPartial('cart', 'member_point_summary')
            .then(function (res) {
              element.html($compile(res.data)(scope));
            })
            .catch(function (err) {
              logger.log('Unable to load member point summary ', err);
            });
        });
      },
    };
  },
]);
